export default {
  common: {
    change: 'Modifier',
    or: 'ou',
    back: 'Retour',
    continue: 'Continuer',
    backToLogin: 'Retour à la connexion',
  },
  fields: {
    name: 'Nom complet',
    email: 'Adresse e-mail',
    password: 'Mot de passe',
    newPassword: 'Mot de passe (8 caractères minimum)',
    confirmPassword: 'Confirmez le mot de passe',
  },
  remembered: {
    forget: 'Oublier ce compte',
    continueAs: 'Continuer en tant que {name}',
    useDifferent: 'Utiliser un autre compte',
  },
  login: {
    welcomeBack: 'Content de vous revoir',
    continueWhereYouLeftOff: 'Reprenez là où vous en étiez',
    rememberAddress: 'Mémoriser mon adresse sur ce navigateur',
    title: 'Connexion',
    subtitle: 'Bienvenue sur {platform}.',
    submit: 'Se connecter',
    forgotPassword: 'Mot de passe oublié ?',
    noAccount: 'Pas encore de compte ?',
    signUp: 'Créer un compte',
    noAccess: 'Pas encore inscrit ?',
    requestAccess: "Faire une demande d'inscription",
    continueWith: 'Continuer avec {provider}',
    ssoFailed: "La connexion par ce fournisseur n'a pas abouti. Réessayez, ou utilisez votre mot de passe.",
    enrolled:
      'La vérification en deux étapes est activée. Reconnectez-vous : un code de votre application vous sera demandé.',
  },
  mfa: {
    title: 'Vérification en deux étapes',
    subtitle:
      "Saisissez le code à six chiffres de votre application d'authentification, ou l'un de vos codes de secours.",
    code: 'Code',
    submit: 'Vérifier',
  },
  enrol: {
    title: 'Configurez la vérification en deux étapes',
    required:
      "Cette plateforme exige la vérification en deux étapes, et ce compte ne l'a pas encore configurée. Configurez-la pour terminer la connexion.",
    scan: "Scannez ce code avec votre application d'authentification, ou saisissez-y la clé.",
    secret: 'Clé',
    code: "Code à six chiffres de l'application",
    submit: 'Activer',
    restart: 'Afficher un nouveau code',
    invalidCode: "Ce code n'a pas fonctionné. Vérifiez l'heure de votre téléphone, puis réessayez.",
    expired: 'Cette configuration a expiré. Reconnectez-vous pour recommencer.',
    alreadyEnrolled: 'La vérification en deux étapes est déjà activée pour ce compte.',
    unavailable: "La vérification en deux étapes n'est pas disponible sur cette plateforme.",
  },
  recoveryCodes: {
    title: 'Vos codes de secours',
    explain:
      'Chaque code ouvre votre compte une fois si vous perdez votre téléphone. Conservez-les en lieu sûr : ils ne seront plus affichés.',
    copy: 'Copier',
    copied: 'Copié',
    saved: 'Je les ai enregistrés',
  },
  reauth: {
    password: 'Mot de passe actuel',
    code: "Code de votre application d'authentification, ou code de secours",
    wrongPassword: 'Mot de passe incorrect.',
    wrongCode: "Ce code n'a pas fonctionné. Réessayez.",
  },
  signup: {
    title: 'Créez votre compte',
    subtitle: 'Rejoignez {platform}.',
    submit: 'Créer le compte',
    sentTitle: 'Consultez votre boîte de réception',
    sent: "Si l'adresse {email} peut être inscrite, un message avec un code et un lien vient de lui être envoyé. Ouvrez le lien, ou connectez-vous pour saisir le code.",
    closed: 'Les inscriptions ne sont pas ouvertes sur cette plateforme. Demandez une invitation à un administrateur.',
    haveAccount: 'Déjà un compte ?',
    signIn: 'Se connecter',
  },
  verify: {
    title: 'Confirmez votre adresse e-mail',
    verifying: 'Confirmation en cours…',
    verified: 'Votre adresse est confirmée.',
    pending: 'Un code a été envoyé à {email}. Saisissez-le ci-dessous, ou ouvrez le lien du même message.',
    code: 'Code de confirmation',
    submit: 'Confirmer',
    resend: 'Recevoir un nouveau code',
    resent: 'Un nouveau message est en route.',
    invalid: "Ce code ou ce lien n'est plus valable. Demandez-en un nouveau.",
    openTheLink: 'Ouvrez le lien du message de confirmation pour terminer.',
  },
  emailChange: {
    confirmTitle: 'Confirmez votre nouvelle adresse',
    confirming: 'Confirmation en cours…',
    confirmed: "Votre adresse a changé. Votre ancienne adresse en a été informée, avec un moyen d'annuler.",
    invalid: "Ce lien n'est plus valable. Redemandez le changement depuis votre profil.",
    openTheLink: 'Ouvrez le lien du message de confirmation envoyé à votre nouvelle adresse.',
    revertTitle: "Annuler le changement d'adresse",
    revertExplain:
      "Si vous n'avez pas demandé ce changement, rétablissez votre ancienne adresse. Toutes les sessions seront déconnectées.",
    revertSubmit: 'Rétablir mon ancienne adresse',
    reverted:
      "{email} est de nouveau votre adresse. Choisissez dès maintenant un nouveau mot de passe : l'auteur du changement connaissait l'ancien.",
    revertedSignIn: '{email} est de nouveau votre adresse. Connectez-vous avec elle.',
    revertInvalid: "Ce lien n'est plus valable.",
    choosePassword: 'Enregistrer le nouveau mot de passe',
    passwordSet: 'Votre mot de passe a été changé. Connectez-vous avec {email}.',
  },
  invitation: {
    title: 'Rejoindre {org}',
    opening: 'Ouverture de votre invitation…',
    invitedBy: '{inviter} a invité {email} à rejoindre {org} en tant que {role}.',
    invited: '{email} est invité à rejoindre {org} en tant que {role}.',
    expires: 'Cette invitation expire le {date}.',
    accept: "Accepter l'invitation",
    wrongAccount:
      'Vous êtes connecté en tant que {current}, mais cette invitation est destinée à {email}. Déconnectez-vous, puis rouvrez le lien.',
    signOut: 'Se déconnecter',
    signIn: 'Se connecter pour accepter',
    createTitle: 'Créez votre compte pour rejoindre {org}.',
    create: 'Créer mon compte et rejoindre',
    accountExists: 'Vous avez déjà un compte avec {email}. Connectez-vous pour rejoindre {org}.',
    invalid:
      "Cette invitation n'est plus valable : elle a expiré, a été retirée ou a déjà été acceptée. Demandez-en une nouvelle.",
    missingToken: "Ouvrez le lien du message d'invitation.",
    joined: 'Vous avez rejoint {org}.',
    alreadyMember: 'Vous faites déjà partie de {org}.',
    open: 'Ouvrir {org}',
  },
  join: {
    opening: 'Ouverture du formulaire…',
    subtitle:
      'Demandez votre inscription à {org}. Un administrateur examinera votre demande ; si elle est acceptée, vous recevrez une invitation par e-mail.',
    requiredLegend: "Les champs marqués d'un * sont obligatoires.",
    linkPlaceholder: 'www.exemple.fr',
    terms: "J'accepte les {link}",
    termsLink: "conditions d'utilisation",
    honeypot: 'Laissez ce champ vide',
    submit: 'Envoyer la demande',
    sentTitle: 'Demande envoyée',
    sent: 'Votre demande a bien été envoyée. Si elle est acceptée, vous recevrez une invitation par e-mail.',
    unavailableTitle: 'Formulaire indisponible',
    unavailable: "Ce formulaire n'est pas disponible.",
    loadFailedTitle: "Le formulaire n'a pas pu être chargé",
    retry: 'Réessayer',
    haveAccount: 'Déjà membre ?',
    refused: "Votre demande n'a pas pu être enregistrée. Corrigez le formulaire, puis réessayez.",
    tooLarge: 'Vos réponses sont trop longues. Raccourcissez-les, puis réessayez.',
    rateLimited: 'Trop de demandes ont été envoyées depuis votre connexion. Réessayez dans une heure.',
    errors: {
      required: 'Ce champ est obligatoire.',
      choose: 'Choisissez une option.',
      email: "Saisissez une adresse e-mail valide, par exemple nom{'@'}exemple.fr.",
      tooLong: '{max} caractères au maximum.',
      number: 'Saisissez un nombre.',
      atLeast: 'Au moins {min}.',
      atMost: 'Au plus {max}.',
      date: 'Saisissez une date.',
      link: "Saisissez l'adresse d'un site, par exemple www.exemple.fr.",
      terms: 'Acceptez les conditions pour envoyer votre demande.',
    },
  },
  forgot: {
    title: 'Mot de passe oublié ?',
    subtitle: 'Saisissez votre adresse e-mail : nous vous enverrons un lien pour en choisir un nouveau.',
    submit: 'Envoyer le lien',
    sent: 'Si un compte existe pour {email}, un lien de réinitialisation est en route.',
    closed:
      "La réinitialisation du mot de passe n'est pas disponible sur cette plateforme. Contactez votre administrateur.",
  },
  reset: {
    title: 'Choisissez un nouveau mot de passe',
    subtitle: 'Vous serez déconnecté partout, puis vous pourrez vous connecter avec le nouveau mot de passe.',
    submit: 'Changer le mot de passe',
    done: 'Votre mot de passe a été changé.',
    invalid: "Ce lien de réinitialisation n'est plus valable. Demandez-en un nouveau.",
  },
  organizations: {
    title: 'Vos organisations',
    signedInAs: 'Connecté en tant que {email}',
    none: "Vous n'appartenez encore à aucune organisation. Demandez à un administrateur de vous inviter.",
    signOut: 'Se déconnecter',
  },
  founding: {
    title: 'Créez votre organisation',
    intro: "Une organisation réunit vos vidéos et les personnes avec qui vous travaillez. Donnez-lui un nom pour commencer.",
    name: "Nom de l'organisation",
    defaultName: 'Organisation de {name}',
    defaultWorkspace: 'Mon espace',
    submit: "Créer l'organisation",
    another: 'Créer une organisation',
    limitReached:
      "Vous possédez déjà le nombre maximum d'organisations autorisé sur cette plateforme ({limit}).",
    unverified: 'Confirmez votre adresse e-mail pour créer une organisation.',
    nameRequired: "Donnez un nom à l'organisation.",
    nameTaken: 'Trop d’organisations portent déjà ce nom sur cette plateforme. Choisissez-en un autre.',
  },
  // An address the platform will not take (`addressRefusal.ts`): it never says which rule refused
  // it. A misspelt webmail is the exception, since the correction is the whole message.
  addressRefusal: {
    signupLasting:
      'Cette adresse e-mail ne peut pas être utilisée ici. Inscrivez-vous avec une adresse durable : celle de votre travail, ou d’une messagerie que vous gardez.',
    signupMisspelt: 'Vouliez-vous dire {address} ? Corrigez l’adresse : celle-ci ne recevrait pas notre e-mail de confirmation.',
    // Inside an organization the address is changed in the profile's settings; without one, the
    // person can only open an account at another address.
    foundingLasting:
      'L’adresse e-mail de votre compte ne peut pas être utilisée pour créer une organisation ici. Remplacez-la par une adresse durable, celle de votre travail ou d’une messagerie que vous gardez, dans les paramètres du profil.',
    foundingLastingNoOrganization:
      'L’adresse e-mail de votre compte ne peut pas être utilisée pour créer une organisation ici. Créez un compte avec une adresse durable, celle de votre travail ou d’une messagerie que vous gardez, puis l’organisation depuis ce compte.',
    foundingMisspelt:
      'L’adresse e-mail de votre compte semble mal orthographiée : vouliez-vous dire {address} ? Corrigez-la dans les paramètres du profil, puis créez l’organisation.',
    foundingMisspeltNoOrganization:
      'L’adresse e-mail de votre compte semble mal orthographiée : vouliez-vous dire {address} ? Créez un compte à cette adresse, puis l’organisation depuis ce compte.',
  },
  errors: {
    credentials: 'Adresse e-mail ou mot de passe incorrect.',
    rateLimited: 'Trop de tentatives. Patientez un instant avant de réessayer.',
    passwordLoginClosed: "La connexion par mot de passe n'est pas disponible sur cette plateforme.",
    mailUnavailable: "Aucun e-mail ne peut être envoyé depuis cette plateforme pour l'instant. Réessayez plus tard.",
    passwordTooShort: 'Au moins {min} caractères.',
    passwordMismatch: 'Les deux mots de passe diffèrent.',
    network: 'Le serveur est injoignable. Vérifiez votre connexion et réessayez.',
    generic: "Une erreur s'est produite. Réessayez.",
  },
}
